import CommunityPostCreate from "./CommunityPostCreate";
import CommunityPostEdit from "./CommunityPostEdit";
import CommunityPostList from "./CommunityPostList";
import CommunityPostShow from "./CommunityPostShow";

const communityPosts = {
  list: CommunityPostList,
  create: CommunityPostCreate,
  edit: CommunityPostEdit,
  show: CommunityPostShow,
};

export default communityPosts;
